import { module } from 'modujs';
import { EAGER_FONTS } from '../app';
import { whenReady } from '../utils/fonts';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        whenReady(EAGER_FONTS).then((fonts) => this.onFontsLoaded(fonts));
    }

    onFontsLoaded(fonts) {
        [...this.el.querySelectorAll(".c-article_side_index_link")].forEach((link) => {
            link.addEventListener("click", (e, i) => {
                [...this.el.querySelectorAll(".c-article_side_index_link")].forEach((link, i) => {
                    link.classList.remove("-active")
                })
                const el = e.target
                if(el.classList.contains("-active")) {
                    el.classList.remove("-active")
                }
                else {
                    el.classList.add("-active")
                }
            })
        })
    }
}
